module.exports = __webpack_public_path__ + "static/fonts/Fact-Compressed.9bb056a.woff2";